/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kn_Health_DegradedInputs */

const cs_kn_health_degraded = /** @type {(inputs: Kn_Health_DegradedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Služba omezená`)
};

const en_kn_health_degraded = /** @type {(inputs: Kn_Health_DegradedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service degraded`)
};

/**
* | output |
* | --- |
* | "Service degraded" |
*
* @param {Kn_Health_DegradedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const kn_health_degraded = /** @type {((inputs?: Kn_Health_DegradedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kn_Health_DegradedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kn_health_degraded(inputs)
	return cs_kn_health_degraded(inputs)
});